define('adminEmailAddressesListView',[
  'module',
  'app',
  'backbone',
  'underscore',
  'jquery',
  'windows',
  'tableView',
  'tableFieldView',
  'adminEmailAddressesListHeaderToolsView',
  'adminEmailAddressesListRowToolsView',
  'adminEmailAddressesEditPopupView',
  'entities/admin/email_addresses'
], function (
  Module,
  App,
  Backbone,
  _,
  $,
  Windows,
  TableView,
  FieldView,
  HeaderToolsView,
  RowToolsView,
  EditPopupView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'admin-email-addresses-list-view ' + TableView.prototype.className,
    pageMode: 'pagination',

    onBeforeShow: function () {
      if (TableView.prototype.onBeforeShow) {
        TableView.prototype.onBeforeShow.apply(this, arguments);
      }
      App.emailAddressesCanEdit = false;
      App.request('emailAddresses:canEdit').done(function (canEdit) {
        App.emailAddressesCanEdit = canEdit === true;
      });
    },

    setFields: function () {
      return [{
        name: 'Email',
        label: _.i18n('common.email'),
        className: 'email',
        bind: 'email',
        modelEvent: 'change:email'
      }, {
        name: 'NameFrom',
        label: _.i18n('admin.emailAddresses.nameFrom'),
        className: 'name-from',
        bind: 'nameFrom',
        modelEvent: 'change:nameFrom'
      }, {
        name: 'UserCount',
        label: _.i18n('admin.emailAddresses.userCount'),
        className: 'user-count',
        bind: 'memberCount',
        modelEvent: 'change:memberCount change:members'
      }, {
        name: 'Buttons',
        className: 'buttons',
        view: RowToolsView,
        headerView: HeaderToolsView
      }];
    },

    fetch: function (first, pageSize) {
      var defer = $.Deferred();

      if (this.fetchRequest) {
        this.fetchRequest.abort();
      }

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('emailAddresses:get-url', { first: first, pageSize: pageSize }),
        success: _.bind(function (items) {
          if (!items || items.length === 0) {
            defer.resolve([]);
            return;
          }
          var promises = _.map(items, function (item) {
            return App.request('emailAddresses:get', item.secId).then(function (details) {
              var members = (details && details.members) || [];
              return App.request('emailAddresses:model', {
                secId: item.secId,
                email: item.email,
                nameFrom: item.nameFrom,
                members: members,
                memberCount: members.length
              });
            });
          });

          $.when.apply($, promises).then(function () {
            defer.resolve(_.toArray(arguments));
          });
        }, this)
      });

      return defer.promise();
    },

    fetchCount: function () {
      var defer = $.Deferred();

      if (this.fetchCountRequest) {
        this.fetchCountRequest.abort();
      }

      this.fetchCountRequest = $.ajax({
        url: App.request('emailAddresses:row-count-url'),
        success: function (resp) { defer.resolve(resp); }
      });

      return defer.promise();
    },

    onRowClick: function (rowView) {
      var bodyView = this.bodyView;
      var secId = rowView.model.get('secId');
      App.request('emailAddresses:canEdit').done(function (canEdit) {
        var isEdit = canEdit === true;
        App.emailAddressesCanEdit = isEdit;
        Windows.open({
          view: function () {
            return new EditPopupView({
              emailSecId: secId,
              canEdit: isEdit,
              onConfirm: function () {
                bodyView.fetch();
              }
            });
          },
          title: isEdit ?
            _.i18n('admin.emailAddresses.editUsers') :
            _.i18n('admin.emailAddresses.viewUsers'),
          width: 560,
          height: 620,
          modal: true
        });
      });
    }
  });
});

